import React, { useEffect, useState, useContext } from "react";
import { MyContext } from "../../../MyContext";
import { useSearchParams } from "react-router-dom";
import { useSession } from "../../session/Context";
import CardDetails from "./CardDetails";
import API from "../../Api";
import { toast } from "react-toastify";
import DataList from "./dataList";

export default function Details(props: any) {
  const { brand } = useSession();
  const [credential, setCredential] = useState(props.credential);
  const { onPage, setOnPage } = useContext(MyContext)!;

  useEffect(() => {
    setOnPage(window.location.pathname.substring(1));
    
    const id = credential.credential.credentialSubject.id;
    const version = credential.version;

    if (id && version) {
      API(
        "/api/v1/brand/" +
          (brand === "" ? "root" : brand) +
          "/metadata?type=credential&id=" +
          id +
          "&version=" +
          version
      )
        .then((response) => {
          setCredential({
            credential: response.credential,
            format: "jwt_vc",
            version: version,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, []);

  const action1 = () => {
    toast.error("This feature is coming soon.");
  };

  return (
    <>
      {credential && (
        <>
          <div className="mobile-pro">
            <div className="login">
              <img src="img/issue-icon-default.svg" />
              <h2>Credential details</h2>
            </div>
          </div>

          <div className="col-content">
            <div className="notifications-container">
              <div className="messages m-hide">
                <p className="light"></p>
                <h2>Credential details</h2>
              </div>

              <div
                style={{
                  textAlign: "center",
                  display: "flex",
                  flexWrap: "wrap",
                  maxWidth: "600px",
                }}
              >
                <div className="container-toggle" style={{ margin: "auto" }}>
                  <CardDetails style="details" credential={credential} />
                </div>

                <div className="card-btn">
                  <button className="btn btn-primary row" onClick={action1}>
                    {" "}
                    New version{" "}
                  </button>
                  <br></br>
                  <button className="btn btn-secondary row" onClick={action1}>
                    {" "}
                    Revoke credential{" "}
                  </button>
                </div>
              </div>

              <br></br>

              {credential && (
                <DataList
                  details={credential.credential.credentialSubject}
                  credentialData={credential}
                />
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
}
